// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"3f6244da","769":"0ee1f7b2"}[chunkId] + ".chunk.js";
};